import { DestroyRef, inject, Injectable } from '@angular/core';

/**
 * Aviso de «la organización de la sesión cambió» (otro token de Sirius con otra `current_logged_organization`, o
 * cierre de sesión). `AuthService` lo emite; los servicios con caché (catálogos, «usado por», credenciales,
 * etiquetas de modelo, proveedores) y los streams SSE se registran con `onOrganizationChange()` y vacían lo suyo
 * para no mostrar datos de la organización anterior. Es una lista de callbacks sin dependencia de `AuthService`,
 * así que un spec que sustituye `AuthService` por un objeto parcial no la rompe.
 */
@Injectable({ providedIn: 'root' })
export class OrganizationChanges {
  private readonly listeners = new Set<() => void>();

  /** Registra un oyente; devuelve la función para quitarlo. */
  listen(listener: () => void): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  /** Avisa a todos los oyentes (lo llama `AuthService`). */
  notify(): void {
    for (const listener of this.listeners) listener();
  }
}

/** Ejecuta `callback` cada vez que cambia la organización de la sesión. Llamar desde un constructor (contexto de inyección). */
export function onOrganizationChange(callback: () => void): void {
  const off = inject(OrganizationChanges).listen(callback);
  inject(DestroyRef, { optional: true })?.onDestroy(off);
}

/** Clave de almacenamiento local propia de la organización (`org:<id>:ae.playground.vars.<slug>`): nada de una organización se lee en otra. */
export function orgScopedKey(organizationsId: number, key: string): string {
  return `org:${organizationsId}:${key}`;
}
